import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 17",
	fill: "none",
	stroke: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.6667 7.83325H3.33333C2.59695 7.83325 2 8.43021 2 9.16659V13.8333C2 14.5696 2.59695 15.1666 3.33333 15.1666H12.6667C13.403 15.1666 14 14.5696 14 13.8333V9.16659C14 8.43021 13.403 7.83325 12.6667 7.83325Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.66663 7.83344V5.16677C4.6658 4.34013 4.97215 3.54268 5.52621 2.92921C6.08027 2.31575 6.84251 1.93004 7.66496 1.84696C8.48741 1.76389 9.31139 1.98937 9.97694 2.47964C10.6425 2.96992 11.1021 3.69 11.2666 4.5001",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgLock;
